import { ArrowRight } from "lucide-react";
import { CTA } from "@/constants/testIds";

export default function FinalCTA() {
  return (
    <section id="contact" className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 md:pb-28">
        <div className="relative overflow-hidden rounded-3xl bg-slate-900 text-white p-10 md:p-16 reveal">
          <div
            className="absolute inset-0 opacity-30 pointer-events-none"
            style={{
              backgroundImage:
                "url(https://images.unsplash.com/photo-1709626011485-6fe000ea2dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGJsdWUlMjBkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc4MzM0MzU3OHww&ixlib=rb-4.1.0&q=85)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-slate-900 via-slate-900/80 to-transparent" />

          <div className="relative max-w-3xl">
            <div className="text-xs font-bold uppercase tracking-widest text-blue-300">Ready to grow?</div>
            <h2 className="mt-3 font-display text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight">
              Ready to grow your traffic, leads and conversions?
            </h2>
            <p className="mt-4 text-slate-300 text-base md:text-lg leading-relaxed">
              Book your free growth audit today. No obligations — just honest, tactical advice you can use.
            </p>
            <a
              href="#free-audit-form"
              data-testid={CTA.final}
              className="mt-8 inline-flex items-center gap-2 bg-blue-600 text-white hover:bg-blue-700 font-semibold py-4 px-7 rounded-full transition-all shadow-lg shadow-blue-600/40 active:scale-95"
            >
              Book Free Growth Audit <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
